import { Box, Stack, Typography } from "@mui/material";

import { SHIPPING, TERMS } from "../../constants";
import { LogoImage } from "../../svgs";
import { HubHookFormInput } from "../HubHookFormInput";
import { HubHookFormDatePicker } from "../HubHookFormDatePicker";
import { HubHookFormSelect } from "../HubHookFormSelect";

import PurchaseOrderLabel from "./PurchaseOrderLabel";

import { StyledFobStack, StyledHeaderStack } from "./styles";
import { FoundryInfo } from "../FoundryInfo";

const CompanyInfo = ({ poNumber = "Unassigned" }) => {
  return (
    <StyledHeaderStack>
      <Stack width="fit-content">
        <FoundryInfo poNumber={poNumber} />
      </Stack>
      <Stack justifyContent="center" alignItems="center">
        <Box component="img" src={LogoImage} height="60px" />
        <Typography variant="boldCaptionL" fontSize="14px" lineHeight="14px">
          Purchase Order
        </Typography>
      </Stack>
      <StyledFobStack>
        <PurchaseOrderLabel label="No." value={poNumber} valueBold />
        {/* <PurchaseOrderLabel label="PO. DATE" value="9/18/2025" valueBold /> */}
        <HubHookFormDatePicker
          name="createdAt"
          label="PO. DATE"
          shouldUnregister={false}
          formProps={{
            sx: {
              ".MuiFormControl-root": { gridTemplateColumns: "1fr !important" },
            },
          }}
          disableHelperText
          required
        />
        <HubHookFormSelect
          name="terms"
          label="Terms"
          options={TERMS}
          shouldUnregister={false}
          disableHelperText
          required
        />
        <HubHookFormInput
          name="freight"
          label="F.O.B"
          placeholder="Lindon"
          shouldUnregister={false}
          disableHelperText
          required
        />
        <HubHookFormSelect
          name="shipVia"
          label="Ship Via"
          className="isLast"
          options={SHIPPING}
          shouldUnregister={false}
          disableHelperText
          required
        />
      </StyledFobStack>
    </StyledHeaderStack>
  );
};

export default CompanyInfo;
